module.exports = __webpack_public_path__ + "static/logo2-75237874b0c758c74b994170075f46ed.png";